import React from 'react';

function BrandLogo({ className = 'h-11 w-11', title = 'Clear Horizons logo' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="18" fill="#F8FAFC" />
      <rect x="1" y="1" width="62" height="62" rx="17" stroke="#CBD5E1" strokeWidth="2" />
      <path
        d="M14 36C19.8 27.9 25.9 23.9 32.4 23.9C38.9 23.9 44.8 27.9 50 36"
        stroke="#0F172A"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M19 42H45"
        stroke="#2563EB"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M27 49C29.4 45.4 31.1 42.6 32 40.5C32.9 42.6 34.6 45.4 37 49"
        stroke="#0F766E"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="32" cy="20" r="5" fill="#F59E0B" />
      <circle cx="32" cy="20" r="8" stroke="#F59E0B" strokeOpacity="0.22" strokeWidth="4" />
    </svg>
  );
}

export default BrandLogo;
